import React from "react";
import InfoIcon from "@mui/icons-material/Info";

/**
 * Standard informational callout used across the employee profile subtabs.
 */
function EmployeeProfileInfoBanner({ children, className = "" }) {
  return (
    <div
      className={`bg-blue-50 border border-blue-200 rounded-lg p-3 mb-6 ${className}`}
    >
      <div className="flex items-start gap-2.5">
        <InfoIcon
          className="text-blue-600 flex-shrink-0 mt-0.5"
          style={{ fontSize: "18px" }}
        />
        <p className="text-sm text-blue-800 leading-relaxed">{children}</p>
      </div>
    </div>
  );
}

export default EmployeeProfileInfoBanner;
